import Layout from '@/components/Layout';

export default [
  {
    path: '/alerts',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/alert'),
        name: 'alerts',
        meta: {
          title: '报警记录',
          attachProject: true,
        },
      },
    ],
  },
];
